import request from '../http/request'

import { accountPrefix, authPrefix } from "../config"

export function getLogin(query) {
    return request({
        url: `${accountPrefix}/paas/account/login`,
        method: "post",
        data: query,
    });
}

export function getLogOut(query) {
    return request({
        url: `${accountPrefix}/paas/account/logout`,
        method: "post",
        data: query,
    });
}

export function getLoginInnerInfo() {
    return request({
        url: `${authPrefix}/auth/login/inner/loginInfo`,
        method: "get",
    });
}

export function getLoginWebsites() {
    return request({
        url: `${authPrefix}/auth/login/loginWebsites`,
        method: "get",
    });
}

export function getRefreshTime(query) {
    return request({
        url: `${accountPrefix}/paas/account/token/refresh/time`,
        method: "post",
        data: query,
    });
}
export function getAndTokeUrl(url) {
    return request({
      url: url,
      method: 'get',
    })
  }
